const pageTitles = {
  login        : "Baaldahab | Login",
  registration : "Baaldahab | Registration",
  feed         : "Baaldahab | Feeds",
  user         : "Baaldahab | User",
  album        : "Baaldahab | Album",
  post         : "Baaldahab | Post",
  media        : "Baaldahab | Media",
  promotion    : "Baaldahab | Promotion",
  notFound     : "Baaldhab  | Page Not Found",
  chat         : "Baaldhab  | Chat",
  search       : "Baaldhab  | Search",
  polling      : "Baaldhab  | Polling"
};

export default pageTitles;